"use strict";

angular.module("internal.exams").controller("InternalExamPermissionLocation", [
    "$scope",
    "EXLocation",
    "$stateParams",
    "$state",
    "$window",
    '$rootScope',
    function (
        $scope,
        EXLocation,
        $stateParams,
        $state,
        $window,
        $rootScope
    ) {
        $scope.editHistory = {};
        $scope.location = { activeStatus: true };
        $scope.addAnotherLocationBool = false;
        $scope.saveMessage = $stateParams.saveMessage;

        $scope.parameters = {
            locationIntegrationId: $rootScope.locationIntegration.id
        };
        $scope.locationIntegrationEnabled = $rootScope.locationIntegration.enable;
        $scope.selectedLocation = null;

        if ($stateParams.examLocationID != null) {
            EXLocation.getlocation($stateParams.examLocationID).then(function (Location) {
                // formatting for edit history helper 
                $scope.locationEditHistory = {
                    createdby: Location.createdByFullName,
                    modifiedby: Location.modifiedByFullName,
                    createdon: Location.createdOnUtc,
                    modifiedon: Location.modifiedOnUtc
                };
                $scope.location = Location;
            });
        } else if ($stateParams.copyLocation != null) {
            // if copied 
            $scope.location = $stateParams.copyLocation;
        }

        $scope.save = function () {
            EXLocation.save($scope.location).then(function (location) {
                $scope.saving = false;
                if (location != null) {
                    if ($scope.addAnotherLocationBool) {
                        $state.go("internal.exams.administrative.location", { examLocationID: null, copyLocation: null });
                    } else {
                        $state.go("internal.exams.administrative.location", { examLocationID: location.id, copyLocation: null, saveMessage: "Record updated successfully" });
                        $scope.addAnotherSkillBool = false;
                    }
                } else {
                    $scope.saveMessage = "Error: Save failed";
                    $window.scrollTo(0, 0);
                }
            });
        };

        $scope.delete = function () {
            if ($scope.location.numOfSessions != null && $scope.location.numOfSessions > 0) {
                $scope.saveMessage = "Please re-assign the associated exam session(s) to a different Location in order for deletion";
                $window.scrollTo(0, 0);
            } else {
                $scope.deleting = true;
                if (window.confirm("Are you sure you want to delete this location?")) {
                    EXLocation.delete($scope.location.id).then(function () {
                        $scope.deleting = false;
                        $state.go("internal.exams.administrative.locations");
                    });
                } else {
                    $scope.deleting = false;
                }
            }

        };

        $scope.copy = function () {
            $scope.copying = true;
            var copiedLocation = angular.copy($scope.location);

            delete copiedLocation.id;
            copiedLocation.name = "Copy of " + copiedLocation.name;

            $state.go("internal.exams.administrative.location", { examLocationID: null, copyLocation: copiedLocation });
        };

        $scope.addAnotherLocation = function () {
            $scope.addAnotherLocationBool = true;
            $scope.save();
        };
    }
]); 
